<template>
  <v-layout row class="selectable" @click="rowClicked">
    <v-flex sm1 xs2 class="align-self-center">
      <v-icon medium>mdi-account-multiple</v-icon>
    </v-flex>
    <v-flex sm3 xs4 pr-2>
      <div class="student-name prevent-overflow">
        <span v-if="nameBreakType === undefined || nameBreakType === 'both'">
            {{intervention.student.firstName | nameBreak(nameBreakSize)}} {{intervention.student.lastName | nameBreak(nameBreakSize)}}
          </span>
        <span v-else-if="nameBreakType === 'combined'">
            {{combineStudentName | nameBreak(nameBreakSize)}}
          </span>
        <span v-else>
            {{intervention.student.firstName}} {{intervention.student.lastName}}
          </span>
      </div>
      <div class="caption prevent-overflow">{{getDisplayId | nameBreak}}</div>
      <span v-if="$vuetify.breakpoint.xsOnly">
        {{$t('intervention_status_'+ intervention.status)}}
      </span>
    </v-flex>
    <v-flex sm2 xs3>
      <div class="prevent-overflow">{{$t(intervention.category.description) | nameBreak}}</div>
      <div class="caption">{{$t('interventions_intervention_id')}} {{intervention.id}}</div>
      <div class="hidden-sm-and-up align-self-center">
        {{intervention.creationDate | date}}
      </div>
    </v-flex>
    <v-flex sm3 class="hidden-xs-only align-self-center">
      {{intervention.creationDate | date}}
    </v-flex>
    <v-flex sm3 xs3 pl-1 class="align-self-center" v-if="$vuetify.breakpoint.smAndUp">
      <span v-if="intervention.status === 'CLOSED'" class="status-complete">
        <v-icon>mdi-check-all</v-icon>
        {{$t('intervention_status_'+ intervention.status)}}
      </span>
      <span v-if="intervention.status === 'DELAYED'" class="status-delayed">
        <v-icon>mdi-clock-alert</v-icon>
        {{$t('intervention_status_'+ intervention.status)}}
      </span>
      <span v-if="intervention.status === 'IN_PROGRESS'" class="status-in-progress">
        <v-icon>mdi-update</v-icon>
        {{$t('intervention_status_'+ intervention.status)}}
      </span>
      <span v-if="intervention.status === 'NEW'">
        <v-icon>mdi-alert-decagram</v-icon>
        {{$t('intervention_status_'+ intervention.status)}}
      </span>
    </v-flex>
    <v-flex style="position: relative;">
      <v-menu v-if="showMenu" @click.native.stop lazy top class="menu-button">
        <v-btn flat small ripple icon slot="activator" class="ma-0">
          <v-icon>more_horiz</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="deleteIntervention">
            <v-icon class="pr-2">delete</v-icon>
            {{$t('delete')}}
          </v-list-tile>
          <v-list-tile v-if="allowClose" @click="closeIntervention">
            <v-icon class="pr-2">done_all</v-icon>
            {{$t('intervention_close')}}
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment-es6'
  import { mapState, mapGetters } from 'vuex'
  import Roles from '../../mixins/Roles'
  import NameBreak from '../../mixins/NameBreak'
  import { GET_STUDENT_TRUNCATION_SIZE, GET_STUDENT_TRUNCATION_TYPE } from '../../store/getter-types'

  export default {
    name: 'tutor-intervention',
    props: ['intervention'],
    mixins: [Roles, NameBreak],
    computed: {
      ...mapState({
        username: state => state.profile.username
      }),
      ...mapGetters({
        nameBreakSize: GET_STUDENT_TRUNCATION_SIZE,
        nameBreakType: GET_STUDENT_TRUNCATION_TYPE
      }),
      combineStudentName () {
        return this.intervention.student.firstName + ' ' + this.intervention.student.lastName
      },
      createdByOrAdmin () {
        return (this.intervention.creatorUsername.toLowerCase().trim() === this.username.toLowerCase().trim()) || this.isAdmin
      },
      allowDelete () {
        return this.createdByOrAdmin && this.intervention.status !== 'CLOSED'
      },
      allowClose () {
        return this.createdByOrAdmin && this.intervention.status !== 'CLOSED'
      },
      showMenu () {
        return this.allowDelete || this.allowClose
      },
      getDisplayId () {
        return this.intervention.student.displayId ? this.intervention.student.displayId : this.intervention.student.studentIdentifier
      }
    },
    methods: {
      rowClicked () {
        this.$emit('row-clicked', this.intervention)
      },
      deleteIntervention () {
        this.$emit('delete-intervention', this.intervention)
      },
      closeIntervention () {
        this.$emit('close-intervention', this.intervention)
      }
    },
    filters: {
      date (value) {
        return moment(value).format('DD/MM/YYYY')
      }
    }
  }
</script>

<style scoped>
  .selectable {
    cursor: pointer;
  }

  .menu-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 32px;
  }
  .status-complete {
    color: #7DD181
  }
  .status-delayed {
    color: #EE6352
  }
  .status-in-progress {
    color: #3FA7D6
  }
  .status-new {
    color: #7DD181
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/TutorIntervention.vue